<template lang="pug">
    v-form(ref="scheduleForm" id="scheduleForm" lazy-validation v-if="schedule")
        v-layout(row pl-4) 
            v-flex(lg12 md12 xs12 class="caption font-weight-bold") Transaksi Pada :
            v-flex(lg12 md12 xs12)
                v-radio-group(dense v-model="schedule.autoType" row @change="onSelect" :readonly="readOnlyRadioButton")  
                    v-radio(label="Saat Ini (Approval Transaksi)" value="NOW")
                    v-radio(label="Pada Tanggal" value="DATE" color="primary")
                    v-radio(label="Setiap Hari" value="DAILY" color="primary")
                    v-radio(label="Setiap Bulan" value="MONTHLY" color="primary")
            v-flex(lg3 md3 xs12 v-if="schedule.autoType == 'DATE'" pl-6)
                v-layout(row) 
                    v-flex(lg11 md11 xs12)
                        f-date-box(v-model="schedule.startPeriode" label="Tanggal Transaksi" @change="onSelect" :readonly="readOnlyForm")
            v-flex(lg12 md12 xs12 v-if="schedule.autoType == 'DAILY' || schedule.autoType == 'MONTHLY'" pl-6)
                v-layout(row) 
                    v-flex(lg3 md3 xs12)
                        v-flex(lg11 md11 xs12)
                            f-date-box(v-model="schedule.startPeriode" label="Tanggal Mulai" @change="onSelect" :readonly="readOnlyForm")
                    v-flex(lg3 md3 xs12)
                        v-flex(lg11 md11 xs12)
                            f-date-box(v-model="schedule.endPeriode" label="Tanggal Akhir" @change="onSelect" :readonly="readOnlyForm")
                    v-flex(lg2 md2 xs12 v-if="schedule.autoType == 'MONTHLY'")
                        v-flex(lg11 md11 xs12)
                            v-text-field(dense v-model="schedule.dateTransaction" label="Setiap Tanggal" @change="onSelect" :readonly="readOnlyForm" v-numeric-only :rules="[v => !!v && v <= 28 || 'Maksimal Tanggal 28']" persistent-hint hint="Antara 1-28" maxlength="2")
                    v-flex(lg4 md4 xs12)
                        v-flex(lg11 md11 xs12)
                            v-switch(v-model="schedule.transactionOnHoliday" label="Transaksi Pada Hari Libur ?" @change="onSelect" :readonly="readOnlyForm")
                    
</template>
<script>
export default {
    name: "ScheduleForm",
    props: ["value", "readOnly", "readOnlyRadio"],
    data() {
        return {
            schedule: {
                startPeriode: null,
                endPeriode: null,
                autoType: 'NOW',
                note: null,
                dateTransaction: null,
                transactionOnHoliday: false
            },
            readOnlyForm: false,
            readOnlyRadioButton: false
        }
    },
    watch: {
        value(val){
            this.doInit(val);
        },
        readOnly(val){
            this.readOnlyForm = val;
            this.readOnlyRadioButton = val;
        },
        readOnlyRadio(val){
            this.readOnlyRadioButton = val;
        }
    },
    mounted() {
        this.doInit(this.value);
    },
    methods: {
        doInit(values){
            this.schedule = values ? values : {
                productCode: null,
                sourceNumber: null,
                startPeriode: null,
                endPeriode: null,
                requestor: null,
                autoType: 'NOW',
                channel: null,
                note: null,
                dateTransaction: null,
                transactionOnHoliday: null,
                email: null,
                phone: null,
                amount: 0,
                customerId: null,
                areaCode: null,
                countPeriode: null,
                destinationNumber: null,
                listDestination: null
            } 
        },
        onSelect(val){
            this.$emit("input", this.schedule);
        }
    },
}
</script>